import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import {
  IReading,
  ReadingSequenceType,
  ReadingSource,
} from "./meterReading.types"
import { Reading } from "./meterReading"
import type { IRegisterRaw } from "../meterRegister/meterRegister.parser"

export type IReadingRaw = NonNullable<IRegisterRaw["readings"][number]>

function parseReadingSource(input: string): ReadingSource {
  const normalized = input.trim().toLowerCase()

  switch (normalized) {
    case "system":
      return ReadingSource.System
    case "customer":
      return ReadingSource.Customer
    case "smr":
      return ReadingSource.Smart
    case "mmr":
      return ReadingSource.Manual
    case "industry":
      return ReadingSource.Industry
    case "user":
      return ReadingSource.User
    default:
      // Tolerate unmapped upstream values like the Ark parser did — throwing
      // here would fail the whole account meterpoints query over one reading.
      return input as ReadingSource
  }
}

function parseSequenceType(input: string): ReadingSequenceType {
  const normalized = input.trim().toLowerCase()

  switch (normalized) {
    case "normal":
      return ReadingSequenceType.Normal
    case "first":
      return ReadingSequenceType.First
    case "last":
      return ReadingSequenceType.Last
    default:
      // Tolerate unmapped upstream values like the Ark parser did — throwing
      // here would fail the whole account meterpoints query over one reading.
      return input as ReadingSequenceType
  }
}

export const MeterReadingParser: IParser<IReading, IReadingRaw> = {
  toDomain: (rawReading: IReadingRaw) => {
    try {
      return new Reading(
        rawReading.id,
        parseReadingSource(rawReading.source),
        rawReading.cumulative,
        dayjs(rawReading.readingDttm),
        rawReading.unit,
        parseSequenceType(rawReading.sequenceType),
        rawReading.quality,
        rawReading.consumption,
        rawReading.status,
        rawReading.rateName ?? undefined,
        rawReading.meterIdentifier ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
